import React from "react";
import NeoInputText from "../../../../../../design/design_components/neo/form/NeoInputText.base";

export default function TitleText(props) {
  return (
    <>
      <NeoInputText
        value={props.text}
        label={"Título"}
        onChange={(e) => props.setText(e.target.value)}
      />
    </>
  );
}
